import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { joinList, splitList } from "./utils";

export const DEFAULT_RULES = "Κρατάμε ΜΟΝΟ εταιρείες που δηλώνουν στο site τους ότι κάνουν εισαγωγή, διανομή ή χονδρική προϊόντων ΑΛΛΩΝ μαρκών/παραγωγών προς επιχειρήσεις. Εξαιρούνται: μόνο λιανική (e-shop/καταστήματα), παραγωγοί που πουλούν μόνο δικά τους προϊόντα, πράκτορες χωρίς διανομή.";

export const toForm = (p = {}) => ({
  client_name: p.client_name || "",
  product: p.product || "",
  brief: p.brief || "",
  target_types: joinList(p.target_types),
  countries: joinList(p.countries),
  leads_target: p.leads_target || 50,
  max_per_domain: p.max_per_domain || 2,
  verify_rules: p.verify_rules || "",
  budget_usd: p.budget_usd || 0,
});

export const fromForm = (f) => ({
  client_name: f.client_name.trim(),
  product: f.product,
  brief: f.brief,
  target_types: splitList(f.target_types),
  countries: splitList(f.countries),
  leads_target: Number(f.leads_target) || 50,
  max_per_domain: Number(f.max_per_domain) || 2,
  verify_rules: f.verify_rules.trim() || DEFAULT_RULES,
  budget_usd: Number(f.budget_usd) || 0,
});

const Field = ({ label, children }) => (
  <div className="space-y-1.5">
    <Label className="text-xs uppercase tracking-[0.15em] text-slate-500">{label}</Label>
    {children}
  </div>
);

export const BriefFields = ({ value, onChange }) => {
  const [f, setF] = useState(value);
  useEffect(() => setF(value), [value]);
  const set = (k) => (e) => {
    const next = { ...f, [k]: e.target.value };
    setF(next);
    onChange(next);
  };
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="agency-brief-form">
      <Field label="Πελάτης *"><Input value={f.client_name} onChange={set("client_name")} data-testid="brief-client-name-input" /></Field>
      <Field label="Προϊόν"><Input value={f.product} onChange={set("product")} placeholder="π.χ. Premium extra virgin olive oil" data-testid="brief-product-input" /></Field>
      <div className="md:col-span-2">
        <Field label="Brief πελάτη">
          <Textarea rows={3} value={f.brief} onChange={set("brief")} placeholder="Ποιους πελάτες θέλει, κανάλια, τιμολογιακή θέση..." data-testid="brief-text-input" />
        </Field>
      </div>
      <Field label="Τύποι αγοραστών (κόμμα)"><Input value={f.target_types} onChange={set("target_types")} placeholder="delicatessen, department stores" data-testid="brief-target-types-input" /></Field>
      <Field label="Χώρες στα Αγγλικά (κόμμα)"><Input value={f.countries} onChange={set("countries")} placeholder="Germany, France" data-testid="brief-countries-input" /></Field>
      <Field label="Στόχος leads"><Input type="number" min={1} max={500} value={f.leads_target} onChange={set("leads_target")} data-testid="brief-leads-target-input" /></Field>
      <Field label="Μέγ. επαφές ανά εταιρεία"><Input type="number" min={1} max={10} value={f.max_per_domain} onChange={set("max_per_domain")} data-testid="brief-max-per-domain-input" /></Field>
      <Field label="Budget project σε $ (0 = χωρίς όριο)"><Input type="number" min={0} step={0.5} value={f.budget_usd} onChange={set("budget_usd")} data-testid="brief-budget-input" /></Field>
      <div className="md:col-span-2">
        <Field label="Κανόνες ελέγχου site (τι κρατάμε / τι εξαιρούμε)">
          <Textarea rows={3} value={f.verify_rules} onChange={set("verify_rules")} placeholder="π.χ. Μόνο εισαγωγείς/διανομείς/χονδρέμποροι καλλυντικών για τρίτους. Όχι λιανική, όχι κομμωτήρια, όχι παραγωγοί μόνο δικών τους." data-testid="brief-verify-rules-input" />
        </Field>
      </div>
    </div>
  );
};
